import React from 'react';
import PropTypes from 'prop-types';

import {
    TopToolbar,
    ListButton,
    DeleteButton,
    useRecordContext,
    useResourceContext,
    useResourceDefinition,
} from 'react-admin';

import { Permissions } from '@src/global/permissions';

import PremierAccessButton from './PremierAccessButton';
import { ImpersonateButton, EditButtonCustom } from '@src/custom';

const ShowActions = (props) => {
    const {
        record,
        data: propData,
        className,
        hasList: propHasList,
        resource: propResource,
        hasDelete = false,
        hasEdit = false,
    } = props;
    const contextResource = useResourceContext(props);
    const resource = propResource || contextResource;
    const { hasList } = useResourceDefinition(props);
    const contextRecord = useRecordContext(props);
    const data = record || contextRecord || propData;
    const shouldShowList = propHasList || hasList;

    return (
        <TopToolbar className={className}>
            { resource === 'agents' && Permissions('users', 'update') === true && <PremierAccessButton user={data} /> }
            { (resource === 'agents' || resource === 'employees' || resource === 'admins') && <ImpersonateButton record={data} /> }
            {hasEdit ? <EditButtonCustom record={data} resource={resource} /> : null}
            {hasDelete && Permissions(resource, 'delete') === true ? (
                <DeleteButton
                    mutationMode="pessimistic"
                    record={data}
                    resource={resource}
                />
            ) : null}
            { shouldShowList ? <ListButton /> : null }
        </TopToolbar>
    );
};

ShowActions.propTypes = {
    className: PropTypes.string,
    hasList: PropTypes.bool,
    record: PropTypes.object,
    data: PropTypes.object,
    resource: PropTypes.string,
    hasDelete: PropTypes.bool,
    hasEdit: PropTypes.bool,
};

export default ShowActions;
